import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Estimate } from 'models/EstimateModel';


const EstimateList: React.FC = () => {
  const width = { sno: 10, client:36, amount: 12, segment:12,  date: 12, createdby: 12 }
  const [formId, formName] = [Code.Form.Id.ESTIMATE, Code.Form.Name.ESTIMATE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [estimateData, setEstimateData] = useState<Estimate[]>([]); 
  const [selectedEstimate, setselectedEstimate] = useState<Estimate | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Estimate.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Estimate.Number, 
        Name.Estimate.Date, 
        Name.Client.FullName, 
        Name.Estimate.Net,
        Name.Common.SegmentName,
        Name.User.FullName,
      ]),
      user_id: userId,
      location_id: locationId,
    });
    await API.Data.List<Estimate>(url, setEstimateData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.User} value={userId} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, estimateData, setSelectAllChecked,formName)} extra={2} />
              <Control.Grid.Items values={[
                [Title.EstimateNo, width.sno], 
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.Segment, width.segment],
                [Title.Date, width.date],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(estimateData) && (
              <Control.Grid.Row>
                {estimateData.map((estimateData) => { return (
                  <Control.Grid.Data<Estimate> key={estimateData.estimate_id} itemKey={estimateData.estimate_key} data={estimateData} setMenuPosition={setMenuPosition} setSelectedData={setselectedEstimate} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={estimateData.estimate_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, estimateData.estimate_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, estimateData.estimate_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Text value={estimateData.estimate_number} width={width.sno} />
                    <Control.Grid.Link value={Utility.Get.FullName(estimateData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(Privilege, Code.Form.Name.CLIENT, estimateData.client_id)} width={width.client} iframeRef={iframeRef} />
                    <Control.Grid.Items values={[
                      [Utility.Format.Amount(estimateData.estimate_net_amount), width.amount, Code.Align.RIGHT],
                      [estimateData.segment_name, width.segment], 
                      [Utility.Format.DateOnly(estimateData.estimate_date), width.date], 
                      [Utility.Get.FullName(estimateData,Code.Form.Name.USER), width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={estimateData.estimate_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={estimateData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedEstimate?.estimate_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedEstimate?.estimate_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default EstimateList;